import { PropsWithChildren } from "react"
import { useTranslation } from "react-i18next"

import { ADAPTIVE_EMAIL, ADAPTIVE_URL } from "@/constants"

const Row = ({ children }: PropsWithChildren) => (
  <p className="pb-sm text-sm-regular">{children}</p>
)

export const ContactUs = () => {
  const { t } = useTranslation()
  return (
    <div className="p-md">
      <p className="pb-md text-lg-regular">{t("contactUs")}</p>
      <Row>{t("adaptive.london.address")}</Row>
      <Row>{t("adaptive.london.phone")}</Row>
      <Row>{t("adaptive.newYork.address")}</Row>
      <Row>{t("adaptive.newYork.phone")}</Row>

      <a
        className="pr-sm pb-xs text-sm-regular-underlined text-utility-blue-dark-500"
        href={`mailto:${ADAPTIVE_EMAIL}`}
      >
        {ADAPTIVE_EMAIL}
      </a>

      <a
        className="text-sm-regular-underlined text-utility-blue-500"
        href={ADAPTIVE_URL}
        target="_blank"
        onClick={() => {
          window.gtag("event", "outbound_click", {
            destination: ADAPTIVE_URL,
          })
        }}
        rel="noreferrer"
      >
        {t("adaptive.website")}
      </a>
    </div>
  )
}
